import { createAction, props } from '@ngrx/store';
import { CustomerAccount } from './customer-account.model';

export const fetchCustomerAccounts = createAction('[Customer Accounts]: Fetch customer accounts');
export const fetchCustomerAccountsSuccess = createAction(
    '[Customer Accounts]: Fetch customer accounts succeeded',
    props<{
        accounts: CustomerAccount[];
    }>()
);
export const fetchCustomerAccountsFailed = createAction(
    '[Customer Accounts]: Fetch customer accounts failed',
    props<{ error: Error }>()
);
export const selectCustomerAccount = createAction(
    '[Customer Accounts]: Select customer account',
    props<{
        accountId: string;
    }>()
);

export const clearSelectedCustomerAccount = createAction('[Customer Accounts]: Clear selected customer account');
